<script setup lang="ts">
import type { ConcreteComponent } from 'vue'
import type { Article } from '~/types'

interface Props {
  video: Article.Video
}

const props = defineProps<Props>()

const { component: componentForVideo, props: componentProps } = useVideoArticle(props.video)
const component = computed<Maybe<ConcreteComponent | string>>(() => componentForVideo.value ? resolveComponent(componentForVideo.value) : null)
const isExist = computed<boolean>(() => !!(component.value && typeof component.value !== 'string'))
</script>

<template>
  <Component
    :is="component"
    v-if="isExist"
    v-bind="componentProps"
    class="video-article-video"
  />
</template>

<style lang="scss">
.video-article-video {
  @apply w-full aspect-video !important;

  img {
    @apply object-cover !important;
  }
}
</style>
